/**
 * Same-origin `returnTo` / magic-link `callbackURL` helpers.
 *
 * The magic-link callback and `/sign-in?returnTo=` both accept a path to send
 * the customer to after they authenticate. Only root-relative paths are
 * honoured — `//evil.example` (protocol-relative) and absolute URLs are
 * rejected so the sign-in flow can never become an open redirect.
 */
export function isSafeReturnTo(value: string | null | undefined): value is string {
  if (typeof value !== 'string') return false;
  if (!value.startsWith('/')) return false;
  if (value.startsWith('//')) return false;
  if (/[\r\n]/.test(value)) return false;
  return true;
}

/** Build a root-relative return path from a pathname + search params. */
export function buildReturnTo(pathname: string, params: URLSearchParams): string {
  const qs = params.toString();
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return qs ? `${path}?${qs}` : path;
}
